import api from '../../../../Api/html-editor';

const dnxVariableOptions = api.getDnxVariables();
export default dnxVariableOptions;
